<template>
  <el-affix :offset="0">
    <div class="myheader">
      <el-row justify="start">
        <el-col :span="3" style="text-align: left">
          <!-- 这里嵌套el-row为了控制图标显示位置 -->
          <el-tooltip
            content="Home - China National Space Administration"
            placement="bottom-start"
            offset="30"
          >
            <a
              href="https://www.cnsa.gov.cn/english/index.html"
              target="_blank"
            >
              <img
                class="mx-3"
                style="width: 23%; padding-top: 20px; padding-bottom: 20px"
                src="../assets/logo2.png"
              />
            </a>
          </el-tooltip>
          <el-tooltip
            content="Home - Jagannath University"
            placement="bottom-start"
            offset="30"
          >
            <a href="https://jnu.ac.bd/" target="_blank">
              <img
                class="navbar-brand img-responsive center-block mx-1"
                style="width: 28%"
                src="../assets/Bangladesh.png"
                href="#"
              />
            </a>
          </el-tooltip>
        </el-col>
        <el-col :span="6" style="text-align: left; font-weight: 600">
          <el-row>
            <h3 style="padding-top: 20px">
              <router-link
                to="/index"
                class="logotext"
                >{{ $t("barmessage.LOGOtitle") }}</router-link
              >
            </h3>
          </el-row>
          <el-row>
            <h3>
              <router-link
                to="/index"
                class="logotext"
                >{{ $t("barmessage.LOGOtitleregion") }}</router-link
              >
            </h3>
          </el-row>
        </el-col>

        <el-col :span="11" style="padding-top: 35px; text-align: right">
          <el-menu
            style="text-align: right; justify-content: flex-end"
            :default-active="activeRoute"
            mode="horizontal"
            background-color="rgba(255,255,255,0)"
            text-color="white"
            active-text-color="cornflowerblue"
            ellipsis="false"
            :router="true"
            class="no-bottom-line"
          >
            <!-- <el-menu-item
            index="/reportsandstats"
            style="font-size: 1.5rem; "
            >{{$t("barmessage.report")}}</el-menu-item
          > -->
            <!-- style="margin-left: auto" 一种常见的技术是将子元素的 margin-left 设置为 auto。当您将一个子元素的 margin-left 设置为 auto 时，该元素将被推到容器的最右边，同时保持其他元素的左对齐 -->
            <el-menu-item class="custom-active-style" index="/index"
              ><h3>{{ $t("barmessage.Home") }}</h3></el-menu-item
            >
            <el-menu-item class="custom-active-style" index="/querymap"
              ><h3>{{ $t("barmessage.data") }}</h3></el-menu-item
            >
            <el-menu-item index="/about"
              ><h3>{{ $t("barmessage.About") }}</h3></el-menu-item
            >
          </el-menu>
        </el-col>

        <!-- 导航右边的图标按钮 -->
        <el-col :span="1"></el-col>
        <el-col :span="3" style="padding-top: 35px">
          <el-dropdown title="language">
            <img
              class="navbar-brand img-responsive center-block myimg mb-1"
              style="width: 35px"
              src="../assets/icons8-languages-64.png"
            />
            <template #dropdown>
              <el-dropdown-menu>
                <!-- <el-dropdown-item
                  :disabled="language === 'zh'"
                  command="china"
                  @click="handleSetLanguage('zh')"
                  >中文</el-dropdown-item
                > -->
                <el-dropdown-item
                  :disabled="language === 'en'"
                  command="english"
                  @click="handleSetLanguage('en')"
                  >English</el-dropdown-item
                >
                <el-dropdown-item
                  :disabled="language === 'meng'"
                  @click="handleSetLanguage('meng')"
                  >বাংলা</el-dropdown-item
                >
               
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <img
            v-if="!islogin"
            class="navbar-brand img-responsive center-block myimg mb-1"
            style="width: 35px"
            src="../assets/not-logged.png"
            href="#"
            @click="onclicklogin"
            :title="$t('barmessage.login')"
          />
          <img
            v-if="islogin"
            class="navbar-brand img-responsive center-block myimg mb-1"
            style="width: 30px"
            src="../assets/logged.png"
            href="#"
            @click="onclickprofile"
            title="User Profile"
          />
          <a :href="userguideurl" target="_blank" title="User Guide">
            <svg
              viewBox="0 0 25 25"
              height="32px"
              preserveAspectRatio="xMidYMid meet"
              fit=""
              style="pointer-events: none; fill: white"
            >
              <g id="help" class="mb-4">
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
                ></path>
              </g>
            </svg>
          </a>
          -->

         
        </el-col>
      </el-row>
    </div>
  </el-affix>
  <router-view></router-view>
  <login
    v-if="showlogin"
    @logindiablur="onlogindiablur"
    @loginok="onloginok"
    class="logindia"
  ></login>
  <userprofile
    @userprofileblur="onlogindiablur"
    @userlogout="onlogout"
    v-if="showuserprofile"
    class="userprofile"
  ></userprofile>
</template>

<script>
import {
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
  watch
} from "vue";
import { useRouter,useRoute } from "vue-router";
import login from "./usermanage/login.vue";
import userprofile from "./usermanage/userprofile.vue";
// 使用i18对象
import { useI18n } from "vue-i18n";
// import func from "vue-editor-bridge";
//  import {getdatabyuid} from "../js/querydata"
export default {
  components: { login, userprofile },
  name: "myheader1",
  setup() {
    const router = useRouter();
    const route = useRoute();
        
    const activeRoute = ref()

    const { proxy } = getCurrentInstance();
    const app = getCurrentInstance();
    const { t } = useI18n(); //使用i18n对象

    const state = reactive({
      islogin: false, //是否登陆成功
      isuuidmode: false,
      username: "yangjin",
      showlogin: false,
      showuserprofile: false,
      language: "en",
      userguideurl: "/static/Manual_en.pdf",
    });

    onMounted(() => {
      if (proxy.uuid != "") {
        state.isuuidmode = true;
      }
      proxy.$EventBus.on("showlogindialog", onclicklogin);
      proxy.$EventBus.on("changelanguage", onchangelanguage);
      // if (t == {}) console.log(t);

      let url = new URL(window.location.href);
      let hash = url.hash;
      activeRoute.value= '/'+hash.split('#/')[1] || '';
    });

    onUnmounted(() => {
      proxy.$EventBus.off("showlogindialog");
      proxy.$EventBus.off("changelanguage");
    });

    //用户点击导航条的登陆图标
    const onclicklogin = () => {
      state.showlogin = true;
    };
    //用户点击导航条的用户profile图标
    const onclickprofile = () => {
      state.showuserprofile = true;
    };
    //登陆对话框或用户profile对话框失去焦点
    const onlogindiablur = () => {
      state.showlogin = false;
      state.showuserprofile = false;
    };
    const onloginok = (username) => {
      console.log("收到登陆成功消息");
      state.islogin = true;

      app.appContext.config.globalProperties.username = username;
      app.appContext.config.globalProperties.loginstatus = 1; //全局变量
      router.push("querymap");
      proxy.$EventBus.emit("onlogin");
    };
    const onlogout = () => {
      state.islogin = false;
      console.log("收到退出登陆消息");
      app.appContext.config.globalProperties.loginstatus = 0;
      router.push("querymap");
      proxy.$EventBus.emit("onlogout");
    };
    //语言切换
    function handleSetLanguage(lan) {
      proxy.$i18n.locale = lan;
      state.language = lan;
      proxy.$EventBus.emit("changelanguage"); //向所有对象发送切换语言消息
    }
    function onchangelanguage() {
      if (proxy.$i18n.locale === "en")
        state.userguideurl = "/static/Manual_en.pdf";
      else state.userguideurl = "/static/Manual_meng.pdf";
    }

    watch(route, (newRoute) => {
      const currentPath = newRoute.path;
      activeRoute.value=currentPath
    });

    return {
      ...toRefs(state),
      onclicklogin,
      onlogindiablur,
      onloginok,
      onclickprofile,
      onlogout,
      handleSetLanguage,
      activeRoute,
      t,
      route
    };
  },
};
</script>

<style scoped>
h1 {
  cursor: pointer;
  height: 53px;
  font-size: 1.875rem;
  font-family: newfonts;
  color: #fefefe;
  font-weight: lighter;
}
.logindia {
  position: absolute;
  right: 10px;
  top: 58px;
  width: 300px;
  opacity: 1;
  z-index: 9999;
  background: white;
}
.userprofile {
  position: absolute;
  right: 10px;
  top: 58px;
  width: 300px;
  opacity: 1;
  z-index: 9999;
  background: white;
}
.myimg {
  cursor: pointer;
}
.myheader {
  height: 104px !important;
  background-image: url("../assets/head-bg.png");
  align-items: center;
}
.el-menu {
  border: 0 !important;
}
/* 导航栏颜色设置 ，鼠标划过时颜色*/

.el-menu-item:hover {
  background-color: #6b70719b !important;
}
.el-menu-item.is-active {
  background-color: rgba(255, 255, 255, 0) !important;
  border-bottom: 5px solid #ffac40 !important; /* 设置下划线样式 */
}
.logotext{
   text-decoration: none;
   color: white;
   font-size: 1.5rem;
}
@media screen and (max-width: 1600px) {
    .logotext {
      font-size: 1.2rem; /* 屏幕宽度小于 768px 时的字体大小 */
    }
  }
</style>
